/**
 * Detect user messages that trigger assistant preference learning (mirrors orchestration preference_extractor).
 */

const PREFERENCE_LEARNING_PATTERNS = [
  /\b(?:i mean|i meant|actually|no,?\s*(?:use|it's|its))\b/i,
  /\b(?:always use|please use|use)\s+.+/i,
  /\b(?:my preference is|i prefer)\s+.+/i,
];

export function looksLikePreferenceLearningMessage(text: string): boolean {
  const t = (text || '').trim();
  if (!t) return false;
  return PREFERENCE_LEARNING_PATTERNS.some((rx) => rx.test(t));
}
